import { createSlice } from "@reduxjs/toolkit";

//Initial Value of Slice
const initialState = {
    List: [
        {
            Id : "Primary-1",
            OldPassword : "Old Password",
            NewPassword : "New Password",
            ConfirmPassword : "Confirm New Password"
        }
    ]
}

//Action of Slice
const EmpPasswordSlice = createSlice({
    name: "EmpPassword",
    initialState,
    reducers: {}
})

//Export of Slice
export const { } = EmpPasswordSlice.actions;
export default EmpPasswordSlice.reducer; 